import { SmlAsset, SmlJsonQuery } from "@src/types/intelligence-search";
import { NarrativeTextVis, NtvPluginManager, createCustomPhraseFactory } from "@antv/ava-react";
import { Tooltip } from "antd";
import { getMemberColor } from "@src/util/intelligence-search/get-member-info";
import { useApiUrl, useCustomMutation } from "@refinedev/core";
import React from "react";
import { DEFAULT_LIMIT } from "../search-component/order-limit";
import { uniqBy } from "lodash";
import { SpecSectionsBuilder } from "@src/util/intelligence-search/builder/narrative-manager";

const pluginManager = new NtvPluginManager([
    // step2. 通过工厂函数（createXxx）定义插件；
    createCustomPhraseFactory({
        key: "ama-sml-asset",
        content: (value, meta) => {
            const { textColor } = getMemberColor(meta.assetMeta.asset_type);
            return (
                // <Tooltip title={JSON.stringify(meta.a)}>
                <Tooltip title={meta.assetMeta.description}>
                    <span
                        style={{
                            color: textColor,
                        }}
                    >
                        {value}
                    </span>
                </Tooltip>
            );
        },
    }),
]);

export const NarrativeTitle: React.FC<{
    customMetricAssetMeta: SmlAsset[];
    query: SmlJsonQuery;
    productCode: string;
    disable?: boolean;
    isLoading?: boolean;
    limit?: number;
}> = ({ customMetricAssetMeta, query, productCode, disable = false, isLoading, limit = DEFAULT_LIMIT }) => {
    const apiUrl = useApiUrl("semantic");
    const [assetMeta, setAssetMeta] = React.useState<SmlAsset[]>([]);
    const { mutateAsync: analyzeQuery } = useCustomMutation<{ meta: SmlAsset[] }>({
        mutationOptions: {
            retry: 0,
        },
    });

    const analyze = async () => {
        return await analyzeQuery({
            method: "post",
            url: apiUrl + "/analyze",
            values: query,
            successNotification: false,
            errorNotification: false,
            config: {
                headers: {
                    "product-code": productCode,
                },
            },
        }).then((result) => {
            const _assetMeta = uniqBy([...result.data.meta, ...(customMetricAssetMeta ?? [])], (item) => item.name);
            setAssetMeta(_assetMeta);
        });
    };

    React.useEffect(() => {
        analyze();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(query)]);

    if (disable || isLoading) {
        return <></>;
    }

    // Use the builder to create spec
    const specBuilder = new SpecSectionsBuilder(assetMeta, query, limit);
    const spec = specBuilder.build();

    return (
        <div>
            {/* <>{JSON.stringify(query)}</> */}
            <NarrativeTextVis
                spec={spec}
                // step3. 传入 NarrativeTextVis 组件；
                pluginManager={pluginManager}
            />
        </div>
    );
};
